export default {
  path: 'temperature-sensor',
  name: 'TemperatureSensor',
  component: () => import(/* webpackChunkName: "satellite-tracking" */ '../views/TemperatureSensorIndexView.vue')
}
